import MedicalInfoCard from '../components/MedicalInfoCard';

export default function MedicalInfo() {
  return (
    <div className="min-w-screen min-h-screen bg-[#F8F5F2]">
      <div className="w-full flex justify-center py-16 px-4">
        <MedicalInfoCard />
      </div>
    </div>
  );
}
